/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";

import {
  Autocomplete, createFilterOptions, createTheme, TextField, ThemeProvider,
} from "@mui/material";
import {
  Button, IconButton, Modal,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

import {
  clearOperatorExpensesAction,
  clearOperatorExpensesResponseAction,
  createOperatorExpensesAction,
} from "../../../../redux/action-creators/expenseActionCreator";
import { DatePicker } from "../../../../shared/widgets";
import { expenseList } from "../../../../Constant";
import { style3 as useStyles } from "../../../../styles/makeStyles";

const theme = createTheme({
  typography: {
    fontFamily: "Noto Sans",
  },
});

const updateStateFromRowData = (
  rowData,
  allCities,
  allOperators,
  setSelectedCity,
  setSelectedOperator,
  setTextFieldData,
  setDate,
) => {
  if (Object.keys(rowData).length) {
    setSelectedCity(
      allCities.find((city) => city?.cityId === rowData?.cityId),
    );
    setSelectedOperator(
      allOperators.find(
        (operator) => operator?.operatorId === rowData?.operatorId.toString(),
      ),
    );
    setTextFieldData(rowData.expenses);
    setDate(rowData.date);
  }
};

const updateNewData = (
  rowData,
  textFieldData,
  newData,
) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(rowData.expenses)) {
    if (rowData.expenses[key] && !textFieldData[key]) {
      // eslint-disable-next-line no-param-reassign
      newData[key] = 0;
    }
  }
};

const createOrUpdateOperatorExpense = ({
  selectedCity,
  selectedOperator,
  textFieldData,
  rowData,
  date,
  isCloseModal,
  CreateOperatorExpense,
}) => {
  if (
    selectedCity?.cityId
    && selectedOperator?.operatorId
    && date
    && (Object.keys(textFieldData).length || Object.keys(rowData).length)
  ) {
    if (Object.keys(rowData).length) {
      const newData = { ...rowData.expenses, ...textFieldData };
      updateNewData(
        rowData,
        textFieldData,
        newData,
      );

      CreateOperatorExpense({
        cityId: selectedCity?.cityId?.toString(),
        operatorId: selectedOperator?.operatorId,
        date,
        expenses: newData,
        isCloseModal,
      });
    } else {
      CreateOperatorExpense({
        cityId: selectedCity?.cityId?.toString(),
        operatorId: selectedOperator?.operatorId,
        date,
        expenses: textFieldData,
        isCloseModal,
      });
    }
  }
};

const filterOperatorsByCityId = (
  selectedCity,
  setOperatorsList,
  allOperators,
) => {
  if (selectedCity.cityId) {
    setOperatorsList(
      allOperators.filter(
        (item) => item?.cityId === selectedCity?.cityId.toString(),
      ),
    );
  } else {
    setOperatorsList(allOperators);
  }
};

const updateTextFieldData = (
  value,
  id,
  textFieldData,
  setTextFieldData,
) => {
  if (value === "") {
    // eslint-disable-next-line no-param-reassign
    delete textFieldData[id];
    setTextFieldData({ ...textFieldData });
  } else if (!Number.isNaN(Number(value)) && Number(value) >= 0) {
    setTextFieldData({ ...textFieldData, [id]: Number(value) });
  }
};

const updateDate = (date, setDate) => {
  if (date) {
    setDate(moment(date).format("YYYY-MM-DD").toString());
  }
};

const getDateInDatePicker = (rowData, date) => {
  const newDate = rowData?.date || date;
  return newDate ? moment(newDate) : null;
};

const buttonDisabledCondition = (
  selectedCity,
  selectedOperator,
  date,
  textFieldData,
  rowData,
) => {
  const extraConditon = rowData ? !Object.keys(rowData).length : true;
  return (!selectedCity?.cityId
    || !selectedOperator?.operatorId
    || !date
    || (!Object.keys(textFieldData).length && extraConditon)
  );
};

const expenseListTextField = (textFieldData, item) => (textFieldData[item] >= 0 ? textFieldData[item] : "");

function ExpenseModal(props) {
  const classes = useStyles();

  const {
    open,
    setOpen,
    rowData = {},
    createOperatorExpenseResponse,
    setRefresh,
    allOperators,
    testDate,
    allCities,
    CreateOperatorExpense,
    ClearOperatorExpensesResponse,
    ClearOperatorExpenseList,
  } = props;
  const [textFieldData, setTextFieldData] = useState({});
  const [operatorsList, setOperatorsList] = useState(allOperators);
  const [operatorExpenseList, setOperatorExpenseList] = useState([]);
  const [totalExpense, setTotalExpense] = useState(0);
  const [selectedCity, setSelectedCity] = useState({});
  const [selectedOperator, setSelectedOperator] = useState({});
  const [date, setDate] = useState(testDate || "");

  useEffect(() => {
    updateStateFromRowData(
      rowData,
      allCities,
      allOperators,
      setSelectedCity,
      setSelectedOperator,
      setTextFieldData,
      setDate,
    );
  }, [props]);

  useEffect(() => {
    setOperatorExpenseList(props?.operatorExpenseList);
  }, [operatorExpenseList]);

  const handleClose = useCallback(() => {
    setOpen(!open);
  }, [open, setOpen]);

  const saveData = useCallback(
    ({ isCloseModal }) => {
      createOrUpdateOperatorExpense({
        selectedCity,
        selectedOperator,
        textFieldData,
        rowData,
        date,
        isCloseModal,
        CreateOperatorExpense,
      });
    },
    [selectedCity?.cityId, selectedOperator?.operatorId, date, textFieldData, props, setRefresh],
  );

  useEffect(() => {
    if (
      createOperatorExpenseResponse?.success
      && createOperatorExpenseResponse?.isCloseModal
    ) {
      handleClose();
      ClearOperatorExpensesResponse();
      setRefresh(true);
    } else if (
      createOperatorExpenseResponse?.success
      && !createOperatorExpenseResponse?.isCloseModa
    ) {
      setTextFieldData({});
      setOperatorsList(allOperators);
      setTotalExpense(0);
      setSelectedCity({});
      setSelectedOperator({});
      setDate();
      ClearOperatorExpenseList();
      setRefresh(true);
    }
  }, [createOperatorExpenseResponse]);

  const handleSaveClose = useCallback(() => {
    saveData({ isCloseModal: true });
  }, [saveData]);

  const handleSaveContinue = useCallback(() => {
    saveData({ isCloseModal: false });
  }, [saveData]);

  useEffect(() => () => {
    ClearOperatorExpenseList();
  }, []);

  useEffect(() => {
    filterOperatorsByCityId(
      selectedCity,
      setOperatorsList,
      allOperators,
    );
  }, [selectedCity, allOperators]);

  const handleTextFieldChange = useCallback(
    (id, value) => {
      updateTextFieldData(
        value,
        id,
        textFieldData,
        setTextFieldData,
      );
    },
    [textFieldData],
  );

  const calculateTotalExpense = useCallback(() => {
    setTotalExpense(
      Object.values(textFieldData).reduce(
        (partialSum, a) => partialSum + Number(a),
        0,
      ),
    );
  }, [textFieldData]);

  useEffect(() => calculateTotalExpense(), [textFieldData]);

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    stringify: (option) => (option?.displayName ?? option?.cityName),
    limit: 500,
  });

  const renderOption = (renderProps, option) => (
    <li
      {...renderProps}
      key={option?.operatorId ?? option?.cityId}
    >
      {option?.displayName ?? option?.cityName}
    </li>
  );

  const handleDatesChange = (dateProp) => {
    updateDate(dateProp, setDate);
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal data-testid="expense-modal" open={open} onClose={handleClose} className={classes.modal}>
        <div className={classes.container}>
          <div className={classes.contentWrapper}>
            <div className={classes.header}>
              {Object.keys(rowData).length ? (
                <h3 className={classes.headingThree}>Edit Expense</h3>
              ) : (
                <h3 className={classes.headingThree}>New Expense</h3>
              )}
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className={classes.dateWrapper}>
              <DatePicker
                date={getDateInDatePicker(rowData, date)}
                label="Enter Expense Date"
                onDateChange={handleDatesChange}
                className={classes.customDatePickerCss}
              />
            </div>
            <div className={classes.autoCompleteWrapper}>
              <Autocomplete
                data-testid="expense-city"
                className={classes.autoComplete}
                value={selectedCity}
                getOptionLabel={(option) => option.cityName || ""}
                options={allCities}
                filterOptions={filterOptions}
                onChange={(event, newValue) => {
                  setSelectedCity(newValue || {});
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select City" variant="standard" />
                )}
                renderOption={renderOption}
              />
              <Autocomplete
                data-testid="expense-operator"
                className={classes.autoComplete}
                value={selectedOperator}
                getOptionLabel={(option) => option.displayName || ""}
                options={operatorsList}
                filterOptions={filterOptions}
                onChange={(event, newValue) => {
                  setSelectedOperator(newValue || {});
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Operator"
                    variant="standard"
                  />
                )}
                renderOption={renderOption}
              />
            </div>
            <h4 className={classes.headingFour}>Expenses</h4>
            <div className={classes.itemWrapper}>
              {Object.keys(expenseList).map((item) => (
                <TextField
                  key={item}
                  id={`${item}`}
                  className={classes.textField}
                  label={expenseList[item]?.displayName}
                  onChange={(e) => {
                    handleTextFieldChange(item, e.target.value);
                  }}
                  value={expenseListTextField(textFieldData, item)}
                  variant="standard"
                />
              ))}

            </div>
            <h4 className={classes.total}>
              Total Expenses : ₹
              {totalExpense}
            </h4>
            <div className={classes.footerWrapper}>
              <Button
                variant="contained"
                className={classes.cancel}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className={classes.saveClose}
                variant="outlined"
                onClick={handleSaveClose}
                disabled={
                  buttonDisabledCondition(
                    selectedCity,
                    selectedOperator,
                    date,
                    textFieldData,
                    rowData,
                  )
                }
              >
                Save and Close
              </Button>
              {!Object.keys(rowData).length && (
                <Button
                  className={classes.saveContinue}
                  variant="contained"
                  onClick={handleSaveContinue}
                  disabled={
                    buttonDisabledCondition(
                      selectedCity,
                      selectedOperator,
                      date,
                      textFieldData,
                    )
                  }
                >
                  Save and Continue
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </ThemeProvider>
  );
}

function mapStateToProps(state) {
  return {
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    allCities: state.Cities.cities,
    allOperators: state.Operators.operators,
    operatorExpenseList:
      (state
        && state.Expenses
        && state.Expenses.operatorExpenseList
        && state.Expenses.operatorExpenseList.items)
      || [],
    createOperatorExpenseResponse:
      state && state.Expenses && state.Expenses.createOperatorExpenseResponse,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  CreateOperatorExpense: (params) => {
    dispatch(createOperatorExpensesAction(params));
  },
  // FetchOperatorExpenseList: (params) => {
  //   dispatch(fetchOperatorExpensesAction(params));
  // },
  ClearOperatorExpenseList: (params) => {
    dispatch(clearOperatorExpensesAction(params));
  },
  ClearOperatorExpensesResponse: (params) => {
    dispatch(clearOperatorExpensesResponseAction(params));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ExpenseModal));
